/**
 * The app's version stamp.
 *
 * ⚠ THE NUMBER ON THE NEXT LINE IS WRITTEN BY THE BUILD, NOT BY HAND. KBuild's version step
 * rewrites any row matching `export const <NAME>_VERSION: string = "..."` before the compile, so
 * the bundle and `PS Scripts\WACVersionNumber.json` can never disagree. Edit it manually and the
 * next build silently overwrites you - which is the point.
 *
 * It is a SERVER-SAFE shared file in the estate's sense: a bare constant with no
 * `ks.KApplication.version` row, because this app does not load `kalmstromShared4`. It is a static
 * page served from the Azure static website (https://wacappf58706.z1.web.core.windows.net, storage
 * account `wacappf58706`, container `$web`) with no SharePoint context of any kind.
 */
export const WAC_VERSION: string = "1.2.0.7";
